import type { GlobalCrawlConfigInput } from "@repo/adapter-core";
import { GlobalCrawlConfigSchema } from "@repo/adapter-core";
import { z } from "zod";

export const AllhomesAdapterConfigSchema = GlobalCrawlConfigSchema.extend({
  listingType: z.enum(["buy", "rent", "sold"]).default("buy"),
  sortBy: z.string().default("latest"),
});

export type AllhomesAdapterConfig = z.infer<typeof AllhomesAdapterConfigSchema>;

export const ALLHOMES_DEFAULT_CONFIG: GlobalCrawlConfigInput = {
  listingType: "buy",
  sortBy: "latest",
};

export function resolveAllhomesConfig(config: GlobalCrawlConfigInput = {}): AllhomesAdapterConfig {
  const listingType =
    config.listingType && config.listingType !== "any" ? config.listingType : "buy";
  return AllhomesAdapterConfigSchema.parse({
    ...ALLHOMES_DEFAULT_CONFIG,
    ...config,
    listingType,
  });
}
